// extracted by mini-css-extract-plugin
export default {"label":"textarea_label__5INgg","asterisk":"textarea_asterisk__+hPLX","input":"textarea_input__2g0iq","invalid":"textarea_invalid__gLutJ","error":"textarea_error__9GA6d"};